import { AsciidoctorIframeElement } from "./subclasses/AsciidoctorIframeElement";
import { PagedJsIframeElement, PagedJsWindow } from "./subclasses/PagedJsIframeElement";
import { PdfJsIframeElement, PdfJsWindow } from "./subclasses/PdfJsIframeElement";
import { Propage } from "./Propage";

const urlParams = new URLSearchParams(window.location.search);
const modalParam = urlParams.get('modal');

if(modalParam != "false"){
  let modal = document.createElement("div") as HTMLDivElement;
  modal.classList.add("modal");

  let modalContent = `
  <div class="modal-content">
    <span class="close">&times;</span>
    <p>Welcome to this demo of Propage! If you are on a mobile, please open this page on your computer!</p>
    <p>Propage tracks provenance across different instances of an HTML page.
    It implies that theoretically any representation of this page can be manipulated to modify the others.
    Normally, it wouldn't be possible to synchronise a PDF view with its HTML equivalent... But Propage makes it a reality!</p>
    <p>In this demo, on the left is a HTML webpage (generated with Asciidoctor),
    in the middle a paginated version of this same webpage (paginated with <a href="https://pagedjs.org">Paged.js</a>),
    and on the right a PDF of this same webpage (produced with <a href="https://weasyprint.org">WeasyPrint</a>
    and rendered by <a href="https://mozilla.github.io/pdf.js/">PDF.js</a>).</p>
    <p>You can find the source code of this demo on <a href="https://gitlab.com/yanntrividic/propage">yanntrividic/propage</a>.</p>
  </div>
  `

  modal.innerHTML = modalContent
  document.body.append(modal)

  // Get the <span> element that closes the modal
  let close = document.getElementsByClassName("close")[0];

  // When the user clicks on <span> (x), close the modal
  close.addEventListener("click", event => {
    modal.style.display = "none";
  });

  // When the user clicks anywhere outside of the modal, close it
  window.addEventListener("click", event => {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  })
}

let asciidoctorIframe = document.querySelector("#html")! as HTMLIFrameElement ;
let asciidoctor = new AsciidoctorIframeElement("asciidoctor", asciidoctorIframe.contentWindow!) ;
asciidoctor.init();

let pagedJsIframe = document.querySelector("#a5")! as HTMLIFrameElement ;
let pagedJs = new PagedJsIframeElement("pagedJs", pagedJsIframe.contentWindow as PagedJsWindow) ;
pagedJs.init();

let pdfJsIframe = document.querySelector("#a4")! as HTMLIFrameElement ;
let pdfJs = new PdfJsIframeElement("pdfJs", pdfJsIframe.contentWindow as PdfJsWindow) ;
pdfJs.init();

let propage = new Propage([asciidoctor, pagedJs, pdfJs]) ;

window.addEventListener(
  "message",
  (event) => {
    // console.log(event)
    let data ;
    try {
      data = event.data.split(" ");
    } catch {
      console.log(event)
    }
    if (data[0] == "jump" && data.length == 3) {
      let id = data[1] ;
      let name = data[2] ;
      let windows = propage.get_windows_except(name) ;
      windows.forEach(window => window.jump(id)) ;
    } else if (data[0] == "highlight" && data.length == 4) {
      let id = data[1] ;
      let name = data[2] ;
      let state = data[3]=="true"?true: false ;
      let windows = propage.get_windows_except(name) ;
      windows.forEach(window => window.highlight(id, state)) ;
    } else return ;
  },
  false,
);
